import { useLocation } from 'react-router-dom'
import { parse } from 'query-string'

export const useRetailerStockSearch = () => {
    const location = useLocation()
    const retailerId =
        (parse(location.search)['retailerId'] as string | null) || (parse(location.search)['dealer'] as string | null)
    const advertisingLocationIncludeDealerStore = /at_profile/.test(location.search)
    const isRetailerStockSearch =
        (location.pathname.indexOf('retailer/stock') > -1 || advertisingLocationIncludeDealerStore) && !!retailerId

    return [isRetailerStockSearch, retailerId] as [boolean, string]
}
